import { render, staticRenderFns } from "./ElectricityCardDetail.vue?vue&type=template&id=14876fa7&scoped=true&"
import script from "./ElectricityCardDetail.vue?vue&type=script&lang=js&"
export * from "./ElectricityCardDetail.vue?vue&type=script&lang=js&"
import style0 from "./ElectricityCardDetail.vue?vue&type=style&index=0&id=14876fa7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14876fa7",
  null
  
)

export default component.exports